import { toTitleCase } from './TextFormatter';
import { KpiSettingsItem } from '../types/types';

export const getTranslationKeyByCode = (code = '') => {
  switch (code) {
    case 'activationRate30':
      return 'activationRate';
    case 'activationRate60':
      return 'activationRate';
    case 'activationRate90':
      return 'activationRate';
    default:
      return code;
  }
};

export type PercentageParts = {
  isDefined: boolean;
  isZero: boolean;
  arrow: '' | '▲' | '▼';
  abs?: number;
};

export const getPercentageParts = (raw: number | string | null | undefined): PercentageParts => {
  if (raw === null || raw === undefined) return { isDefined: false, isZero: false, arrow: '' };

  const n = typeof raw === 'string' ? parseFloat(raw) : raw;
  if (!Number.isFinite(n as number)) return { isDefined: false, isZero: false, arrow: '' };

  if (n === 0) return { isDefined: true, isZero: true, arrow: '', abs: 0 };
  return {
    isDefined: true,
    isZero: false,
    arrow: (n as number) > 0 ? '▲' : '▼',
    abs: Math.abs(n as number),
  };
};

export const normalizeMetricSourceData = (kpiData: any, labelMapper?: (item: any) => string) => {
  if (!kpiData?.metricSourceData) return undefined;

  return {
    segments: kpiData.metricSourceData.map((item: any) => ({
      label: labelMapper ? labelMapper(item) : toTitleCase(item.keyName || item.key),
      value: item.value || 0,
      dataType: item.dataType,
    })),
  };
};

/**
 * Checks if a KPI code exists in the config array.
 * Supports exact match and startsWith match (case-insensitive).
 */
export const isKpiInConfig = (
  configKpis: KpiSettingsItem[],
  code: string,
  useStartsWith: boolean = false
): boolean => {
  if (!Array.isArray(configKpis) || !configKpis.length) return false;

  const lowerCode = code?.toLowerCase();
  if (!lowerCode) return false;

  return configKpis.some((kpi) => {
    const kpiCode = kpi.code?.toLowerCase();
    if (!kpiCode) return false;
    return useStartsWith
      ? kpiCode === lowerCode || kpiCode.startsWith(lowerCode)
      : kpiCode === lowerCode;
  });
};

export const appendSkuToTableData = (tableData: any) => {
  if (!tableData?.body?.rows || !Array.isArray(tableData.body.rows)) return tableData;

  const updateRow = (row: any): any => {
    if (Array.isArray(row)) {
      return row.map((cell: any) => {
        if (cell && typeof cell === 'object' && cell.kpiCode && cell.kpiValue) {
          return {
            ...cell,
            kpiValue: `${cell.kpiValue} ${cell.kpiCode !== 'OTHERS' ? cell.kpiCode : ''}`,
          };
        }
        return cell;
      });
    }

    if (row && typeof row === 'object') {
      const newRow = { ...row };
      if (newRow.kpiCode && newRow.kpiValue) {
        newRow.kpiValue = `${newRow.kpiValue} ${newRow.kpiCode !== 'OTHERS' ? newRow.kpiCode : ''}`;
      }

      if (newRow.rowComponent && Array.isArray(newRow.rowComponent)) {
        newRow.rowComponent = newRow.rowComponent.map((child: any) => updateRow(child));
      }
      return newRow;
    }

    return row;
  };

  return {
    ...tableData,
    body: {
      ...tableData.body,
      rows: tableData.body.rows.map(updateRow),
    },
  };
};
